import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageLoader from 'components/PageLoader';
import './PublicLayout.scss';

const ROUTE_TITLE_KEY: Record<string, string> = {
  '/trang-chu': 'pageTitle.trangChu',
  '/gioi-thieu': 'pageTitle.gioiThieu',
  '/tin-tuc': 'pageTitle.tinTuc',
  '/tin-tuc/ghtm': 'pageTitle.tinTuc',
  '/tin-tuc/nganh': 'pageTitle.tinTuc',
  '/lien-he': 'pageTitle.lienHe',
  '/tra-cuu': 'pageTitle.traCuu',
  '/tra-cuu/uoc-tinh-cuoc': 'pageTitle.uocTinhCuoc',
};

const PublicLayout: React.FC = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    // Update browser tab title
    const titleKey = ROUTE_TITLE_KEY[pathname] ?? 'pageTitle.default';
    document.title = t(titleKey);

    // Scroll to top instantly on route change
    const html = document.documentElement;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    requestAnimationFrame(() => { html.style.scrollBehavior = ''; });
  }, [pathname, t]);

  return (
    <React.Suspense fallback={<PageLoader />}>
      <Outlet />
    </React.Suspense>
  );
};

export default PublicLayout;
